<template>
  <form @submit.prevent="onSubmit">
    <!-- ----------------- -->
    <!-- TOP ROW (HEADER)  -->
    <!-- ----------------- -->
    <div class="row">
      <p class="bb-page-title mt-3">RACE</p>
    </div>
    <!-- -------------- -->
    <!-- MAIN CONTAINER -->
    <!-- -------------- -->
    <div class="row mt-1 mb-2 m-2">
      <!-- -------------- -->
      <!--    LEFT COL    -->
      <!-- -------------- -->
      <div class="col-4">
        <div class="row">
          <!-- -------------- -->
          <!-- IMAGE          -->
          <!-- -------------- -->
          <div class="form-group text-center">
            <div class="form-floating mb-3">
              <img
                v-bind:src="image"
                class="img-fluid rounded border border-dark bb-image-container"
                alt="race image"
              />
            </div>
            <label class="btn btn-dark btn-file mb-2 bb-click-label">
              Change Image
              <input
                type="file"
                accept="image/*"
                style="display: none"
                id="selectImage"
              />
            </label>
          </div>
        </div>
        <!-- spacer row-->
        <div class="row mt-2 mb-2"></div>
        <!-- -------------- -->
        <!--   ABILITIES    -->
        <!-- -------------- -->
        <!-- -------------- -->
        <!--   sub-heading  -->
        <!-- -------------- -->
        <p class="bb-hdg mb-3">Abilities</p>
        <div>
          <!-- -------------- -->
          <!--    CA (r/o)    -->
          <!-- -------------- -->
          <div class="row mb-2 w-75">
            <div class="form-group">
              <div class="form-floating">
                <input
                  readonly
                  class="form-control text-center"
                  v-model="ca"
                  id="ca"
                  disabled
                />
                <label
                  class="bb-float-label optional"
                  for="ca"
                  >CA</label
                >
              </div>
            </div>
          </div>
          <!-- ----------------- -->
          <!--   calc SR (r/o)   -->
          <!-- ----------------- -->
          <div class="row mb-2 w-75">
            <div class="form-group">
              <div class="form-floating">
                <input
                  readonly
                  class="form-control text-center"
                  v-model="sr"
                  id="sr"
                  disabled
                />
                <label
                  class="bb-float-label optional"
                  for="sr"
                  >SR</label
                >
              </div>
            </div>
          </div>
          <!-- ------------------------------ -->
          <!--   calculated damage mod (r/o)  -->
          <!-- ------------------------------ -->
          <div class="row mb-2 w-75">
            <div class="form-group">
              <div class="form-floating">
                <input
                  readonly
                  class="form-control text-center text-uppercase"
                  v-model="damage_mod"
                  id="damage_mod"
                  disabled
                />
                <label
                  class="bb-float-label optional"
                  for="damage_mod"
                  >Dam Mod</label
                >
              </div>
            </div>
          </div>
          <!-- ------------- -->
          <!--   move        -->
          <!-- ------------- -->
          <div class="row mb-2 w-100">
            <CounterComponent
              :pass_ref="'counter_move'"
              :pass_label="move_label"
              :pass_count="local_race.move"
              :pass_min="move_min"
              :pass_max="move_max"
              :pass_digits="move_digits"
            />
          </div>
          <!-- ------------ -->
          <!--   fly        -->
          <!-- ------------ -->
          <div class="row mb-2 w-100">
            <CounterComponent
              :pass_ref="'counter_move_fly'"
              :pass_label="move_fly_label"
              :pass_count="local_race.move_fly"
              :pass_min="move_fly_min"
              :pass_max="move_fly_max"
              :pass_digits="move_digits"
            />
          </div>
          <!-- ------------- -->
          <!--   override SR  -->
          <!-- -------------- -->
          <div class="row mb-2 w-100">
            <CounterComponent
              :pass_ref="'counter_override_sr'"
              :pass_label="override_sr_label"
              :pass_count="override_sr"
              :pass_min="sr_min"
              :pass_max="sr_max"
              :pass_digits="sr_digits"
            />
          </div>
          <!-- ---------------------- -->
          <!--   override damage mod  -->
          <!-- ---------------------- -->
          <div class="row mb-2 w-75">
            <div class="form-group">
              <div class="form-floating">
                <v-select
                  :options="damage_mods"
                  class="form-control"
                  placeholder="select..."
                  v-model="override_damage_mod"
                  id="override_damage_mod"
                >
                  <template v-slot:selected-option="option">
                    <span class="bb-center-text">
                      {{ option.label }}
                    </span>
                  </template>

                  style="display: flex; align-items: baseline">
                </v-select>
                <label
                  class="bb-float-label"
                  for="override_damage_mod"
                  >Override Dam Mod</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ---------------- -->
      <!--     RIGHT COL    -->
      <!-- ---------------- -->
      <div class="col-7 mx-3">
        <!-- ---------------- -->
        <!-- ROW 1 - NAME     -->
        <!-- ---------------- -->
        <div class="row mb-2">
          <div class="col">
            <div class="form-group">
              <div class="form-floating">
                <input
                  ref="input"
                  v-model="local_race.name"
                  v-bind:class="{
                    'is-invalid': errorFields.includes('name'),
                  }"
                  id="name"
                  name="name"
                  type="search"
                  placeholder="select..."
                  class="form-control capitalize"
                  @keydown="onKeyDown($event)"
                  @click="clearInputError('name')"
                  @mouseup="this.capitaliseHandler(local_race.name)"
                  autocomplete="off"
                  required
                />
                <label
                  class="bb-float-label"
                  for="name"
                  >Name</label
                >
              </div>
            </div>
          </div>
        </div>
        <!-- -------------- -->
        <!--    ERRORS      -->
        <!-- -------------- -->
        <div
          v-if="errors.length > 0"
          class="row mt-3 mb-2"
        >
          <div class="form-group">
            <div
              v-for="err in errors"
              :key="err.id"
              class="bb-error"
            >
              {{ err }}
            </div>
          </div>
        </div>
        <!-- ---------------- -->
        <!-- ROW 2 - CHARS    -->
        <!-- ---------------- -->
        <div class="row mt-4">
          <!-- ------------------ -->
          <!--   CHARACTERISTICS  -->
          <!-- ------------------ -->
          <p class="bb-hdg mt-2 mb-1">Characteristics</p>
          <!-- ----------- -->
          <!--    VALUE    -->
          <!-- ----------- -->
          <div class="col m-3">
            <p class="bb-sub-hdg mt-3 mb-1">Values</p>
            <!-- -------------- -->
            <!--      STR       -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_str'"
                :pass_label="str_label"
                :pass_count="local_race.str"
                :pass_min="local_race.str_min"
                :pass_max="local_race.str_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--      CON       -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_con'"
                :pass_label="con_label"
                :pass_count="local_race.con"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--      DEX       -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_dex'"
                :pass_label="dex_label"
                :pass_count="local_race.dex"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--       SIZ      -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_siz'"
                :pass_label="siz_label"
                :pass_count="local_race.siz"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--       INT       -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_int'"
                :pass_label="int_label"
                :pass_count="local_race.int"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--       POW      -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_pow'"
                :pass_label="pow_label"
                :pass_count="local_race.pow"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--       CHA      -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_cha'"
                :pass_label="cha_label"
                :pass_count="local_race.cha"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
          </div>
          <!-- ----------- -->
          <!--    MINS    -->
          <!-- ----------- -->
          <div class="col m-3">
            <p class="bb-sub-hdg mt-3 mb-1">Minimums</p>
            <!-- -------------- -->
            <!--      STR       -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_str_min'"
                :pass_label="str_label"
                :pass_count="local_race.str_min"
                :pass_min="char_min"
                :pass_max="local_race.str"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--      CON       -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_con_min'"
                :pass_label="con_label"
                :pass_count="local_race.con_min"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--      DEX       -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_dex_min'"
                :pass_label="dex_label"
                :pass_count="local_race.dex_min"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--       SIZ      -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_siz_min'"
                :pass_label="siz_label"
                :pass_count="local_race.siz_min"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--       INT       -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_int_min'"
                :pass_label="int_label"
                :pass_count="local_race.int_min"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--       POW      -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_pow_min'"
                :pass_label="pow_label"
                :pass_count="local_race.pow_min"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--       CHA      -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_cha_min'"
                :pass_label="cha_label"
                :pass_count="local_race.cha_min"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
          </div>
          <!-- ----------- -->
          <!--    MAXS    -->
          <!-- ----------- -->
          <div class="col m-3">
            <p class="bb-sub-hdg mt-3 mb-1">Maximums</p>
            <!-- -------------- -->
            <!--      STR       -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_str_max'"
                :pass_label="str_label"
                :pass_count="local_race.str_max"
                :pass_min="local_race.str"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--      CON       -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_con_max'"
                :pass_label="con_label"
                :pass_count="local_race.con_max"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--      DEX       -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_dex_max'"
                :pass_label="dex_label"
                :pass_count="local_race.dex_max"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--       SIZ      -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_siz_max'"
                :pass_label="siz_label"
                :pass_count="local_race.siz_max"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--       INT       -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_int_max'"
                :pass_label="int_label"
                :pass_count="local_race.int_max"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--       POW      -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_pow_max'"
                :pass_label="pow_label"
                :pass_count="local_race.pow_max"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
            <!-- -------------- -->
            <!--       CHA      -->
            <!-- -------------- -->
            <div class="row mb-2">
              <CounterComponent
                :pass_ref="'counter_cha_max'"
                :pass_label="cha_label"
                :pass_count="local_race.cha_max"
                :pass_min="char_min"
                :pass_max="char_max"
                :pass_digits="char_digits"
              />
            </div>
          </div>
        </div>
        <!-- ---------------- -->
        <!-- ROW 3 - OPTIONS  -->
        <!-- ---------------- -->
        <div class="row mt-3">
          <p class="bb-hdg mb-3 mt-3">Options</p>
          <div class="col">
            <div class="col px-3">
              <!-- ---------------- -->
              <!--  special action  -->
              <!-- ---------------- -->
              <div class="row">
                <enhanced-toggle
                  style="
                    --toggleWidth: 350px;
                    --labelWidth: 300px;
                    --switchWidth: 200px;
                  "
                  :labelOn="`Special Action`"
                  :labelOff="`Normal Actions`"
                  :styleOff="`default`"
                  :styleOn="`primary`"
                  :checked="local_race.special_action"
                  @mouseup="onToggleClick('special_action')"
                  @click.stop="onToggleClick('special_action')"
                >
                </enhanced-toggle>
              </div>
              <!-- ----------------- -->
              <!-- special reaction  -->
              <!-- ----------------- -->
              <div class="row">
                <enhanced-toggle
                  style="
                    --toggleWidth: 350px;
                    --labelWidth: 300px;
                    --switchWidth: 200px;
                  "
                  :labelOn="`Special Reaction`"
                  :labelOff="`Normal Reactions`"
                  :styleOff="`default`"
                  :styleOn="`primary`"
                  :checked="local_race.special_reaction"
                  @mouseup="onToggleClick('special_reaction')"
                  @click.stop="onToggleClick('special_reaction')"
                >
                </enhanced-toggle>
              </div>
              <!-- ----------------- -->
              <!-- character race    -->
              <!-- ----------------- -->
              <div class="row">
                <enhanced-toggle
                  style="
                    --toggleWidth: 350px;
                    --labelWidth: 300px;
                    --switchWidth: 200px;
                  "
                  :labelOn="`Character Race`"
                  :labelOff="`Not Character Race`"
                  :styleOff="`default`"
                  :styleOn="`primary`"
                  :checked="local_race.character_race"
                  @mouseup="onToggleClick('character_race')"
                  @click.stop="onToggleClick('character_race')"
                >
                </enhanced-toggle>
              </div>
            </div>
          </div>
        </div>
        <!-- spacer row-->
        <div class="row mt-3 mb-3"></div>
        <!-- ------------------ -->
        <!-- ROW 4 - BUTTONS    -->
        <!-- ------------------ -->
        <div class="row mt-3 m-1">
          <div
            class="btn-group-lg w-75 mt-3"
            role="group"
          >
            <!-- ------------ -->
            <!--    cancel    -->
            <!-- ------------ -->
            <button
              class="btn btn-lg btn-warning"
              type="button"
              @click="closeSidePanel()"
            >
              Cancel
            </button>
            <!-- ------------ -->
            <!--     add      -->
            <!-- ------------ -->
            <button
              v-if="new_race"
              :disabled="!hasName"
              class="btn btn-primary btn-lg"
              type="submit"
            >
              Add
            </button>
            <!-- ------------ -->
            <!--      ok      -->
            <!-- ------------ -->
            <button
              v-if="!new_race"
              :disabled="!isChanged || !hasName"
              class="btn btn-primary btn-lg"
              type="submit"
            >
              OK
            </button>
            <!-- ------------ -->
            <!--     prev     -->
            <!-- ------------ -->
            <button
              v-if="race != null && raceNames.length > 1"
              type="button"
              class="btn btn-primary btn-lg"
              @click="prevRace()"
            >
              Previous
            </button>
            <!-- ------------ -->
            <!--     next     -->
            <!-- ------------ -->
            <button
              v-if="race != null && raceNames.length > 1"
              type="button"
              class="btn btn-primary btn-lg"
              @click="nextRace()"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { EnhancedToggle } from 'vue-enhanced-check'
import CounterComponent from './Counter.vue'
import { mapGetters } from 'vuex'
import { inject } from 'vue'

import isCharacteristicsChanged from '../helpers/isCharacteristicsChanged'
import capitaliseFirstLetter from '../helpers/capitaliseFirstLetter'
import saveCurrentEditableCharacteristics from '../helpers/saveCurrentEditableCharacteristics'
import isObjectChanged from '../helpers/isObjectChanged'
import copyObjectNoRef from '../helpers/copyObjectNoRef'
import isAlphanumeric from '../helpers/isAlphanumeric'
import loadRaceValues from '../helpers/loadRaceValues'
import setRaceValues from '../helpers/setRaceValues'
import calcDamageMod from '../helpers/calcDamageMod'
import isName from '../helpers/isName'
import calcCA from '../helpers/calcCA'
import calcSR from '../helpers/calcSR'

import defaultImage from '../assets/images/default-race-image.png'

export default {
  name: 'RaceCard',
  //========================================================
  // components
  //------------
  components: {
    EnhancedToggle,
    CounterComponent,
  },
  //========================================================
  // setup
  //-------
  setup() {
    const global = inject('global')
    return { global }
  },
  //========================================================
  // props
  //-------
  props: {
    race: {
      type: Object,
      default: null,
    },
    raceNames: {
      type: Array,
      default: null,
    },
  },
  //========================================================
  // data
  //------
  data() {
    return {
      defaultImage,
      errorFields: [],
      errors: [],
      races: [],
      damage_mods: [],
      config: null,
      new_race: false,
      submitCommitted: false,
      //
      original_race: null,
      original_name: '',
      original_chars: [],
      //
      override_damage_mod: '',
      override_sr: 0,
      override_sr_label: 'Override SR',
      // ------------
      // local race
      // ------------
      local_race: {
        id: 0,
        slug: '',
        name: '',
        label: '',
        //
        ca: 0,
        cr: 0,
        sr: 0,
        move: 0,
        move_fly: 0,
        damage_mod: '',
        //
        str: 0,
        str_min: 0,
        str_max: 0,
        //
        con: 0,
        con_min: 0,
        con_max: 0,
        //
        dex: 0,
        dex_min: 0,
        dex_max: 0,
        //
        siz: 0,
        siz_min: 0,
        siz_max: 0,
        //
        int: 0,
        int_min: 0,
        int_max: 0,
        //
        pow: 0,
        pow_min: 0,
        pow_max: 0,
        //
        cha: 0,
        cha_min: 0,
        cha_max: 0,
        //
        special_action: false,
        special_reaction: false,
        character_race: false,
        image: null,
        image_file: null,
      },
      // -----------------------
      // counter parms (stats)
      // -----------------------
      sr_min: 0,
      sr_max: 0,
      sr_digits: 2,
      // -----------------------
      // counter parms (chars)
      // -----------------------
      char_min: 0,
      char_max: 0,
      char_default_val: 0,
      char_default_min: 0,
      char_default_max: 0,
      char_digits: 2,
      //
      move_min: 0,
      move_max: 0,
      move_fly_min: 0,
      move_fly_max: 0,
      move_digits: 2,
      //
      str_label: 'Str',
      con_label: 'Con',
      dex_label: 'Dex',
      siz_label: 'Siz',
      int_label: 'Int',
      pow_label: 'Pow',
      cha_label: 'Cha',
      move_label: 'Move',
      move_fly_label: 'Fly',
    }
  },
  //========================================================
  // watch
  //-------
  watch: {
    race(newValue) {
      if (newValue != null) {
        this.original_name = newValue.name
        this.loadRace(newValue, this.char_default_val)
        this.new_race = false
      }
    },
    ca(newValue) {
      this.local_race.ca = newValue
      if (this.original_race.ca == 0) {
        this.original_race.ca = newValue
      }
    },
    cr(newValue) {
      this.local_race.cr = newValue
      if (this.original_race.cr == 0) {
        this.original_race.cr = newValue
      }
    },
    sr(newValue) {
      this.local_race.sr = newValue
      if (this.original_race.sr == 0) {
        this.original_race.sr = newValue
      }
    },
    damage_mod(newValue) {
      this.local_race.damage_mod = newValue
      if (this.original_race.damage_mod == '') {
        this.original_race.damage_mod = newValue
      }
    },
  },
  //========================================================
  // computed
  //----------
  computed: {
    ca() {
      return calcCA(this.local_race.dex)
    },
    cr() {
      return this.local_race.ca
    },
    sr: {
      get() {
        if (this.override_sr > 0) {
          return this.override_sr
        } else {
          return calcSR(this.local_race.int, this.local_race.dex)
        }
      },
    },
    damage_mod: {
      get() {
        if (this.override_damage_mod != '') {
          return this.override_damage_mod
        } else {
          return calcDamageMod(this.local_race.str, this.local_race.siz)
        }
      },
    },
    //----------
    // has name
    //----------
    hasName() {
      if (this.local_race.name == '' || this.local_race.name == undefined) {
        return false
      } else {
        return true
      }
    },
    //------------
    // is changed
    //------------
    isChanged() {
      return isObjectChanged(this.original_race, this.local_race)
    },
    //------------------
    // is chars changed
    //------------------
    isCharsChanged() {
      return isCharacteristicsChanged(this.original_race, this.local_race)
    },
    //========================================================
    // determine race image
    //----------------------
    image: function () {
      if (this.local_race.image != null) {
        return this.local_race.image
      } else {
        return this.defaultImage
      }
    },
  },
  //========================================================
  // methods
  //---------
  methods: {
    //========================================================
    // save original race state
    //-------------------------
    syncOriginalRaceState() {
      this.original_race = copyObjectNoRef(this.local_race)
      this.original_chars = saveCurrentEditableCharacteristics(this.local_race)
    },
    //========================================================
    // ref mapped methods
    //--------------------
    ...mapGetters('combat', {
      getConfig: 'getConfig',
    }),
    //========================================================
    // capitalise handler
    //--------------------
    capitaliseHandler(str) {
      this.local_race.name = capitaliseFirstLetter(str)
    },
    //========================================================
    // get dropdown values
    //---------------------
    getDropDownValues() {
      // console.log("-----------------------")
      // console.log("IN getDropDownValues")
      // get config
      this.config = this.getConfig()
      // load counter min/max values (stats)
      this.sr_min = this.config.min_sr
      this.sr_max = this.config.max_sr
      this.ca_min = this.config.min_ca
      this.ca_max = this.config.max_ca
      this.cr_min = this.config.min_cr
      this.cr_max = this.config.max_cr
      // load default counter min/max values (chars)
      this.char_max = this.config.max_limit_char
      this.char_min = this.config.min_limit_char
      //
      this.move_min = this.config.min_move
      this.move_max = this.config.max_move
      this.move_fly_min = this.config.min_move_fly
      this.move_fly_max = this.config.max_move_fly
      //
      this.char_default_val = this.config.val_default_char
      this.char_default_min = this.config.min_default_char
      this.char_default_max = this.config.max_default_char
      //
      this.damage_mods = this.config.damage_mods
    },
    //========================================================
    // clear specific input error
    //----------------------------
    clearInputError(field) {
      if (this.errorFields.length > 0) {
        const index = this.errorFields.indexOf(field)
        if (index != -1) {
          this.errors.splice(index, 1)
          this.errorFields.splice(index, 1)
        }
      }
    },
    //========================================================
    // load race
    //-----------
    loadRace(existing_race, default_char_default_val) {
      this.local_race = loadRaceValues(
        existing_race,
        default_char_default_val,
        this.char_min,
        this.char_max,
      )
      this.syncOriginalRaceState()

      this.chkToggleClick('special_action', existing_race.special_action)
      this.chkToggleClick('special_reaction', existing_race.special_reaction)
      this.chkToggleClick('character_race', existing_race.character_race)
    },
    //========================================================
    // on submit
    //-----------
    onSubmit() {
      if (this.submitCommitted) {
        return
      }

      this.errors = []
      this.errorFields = []
      //-----------------
      // capitalise name
      //-----------------
      this.local_race.name = capitaliseFirstLetter(this.local_race.name)
      //----------------------
      // check name not exist
      //----------------------
      if (this.local_race.name != this.original_name) {
        if (isName(this.local_race.name, this.raceNames)) {
          this.errors.push('Name already exists.')
          this.errorFields.push('name')
        }
      }
      //-------------------
      // check name length
      //-------------------
      if (this.local_race.name.length < 3) {
        //---------------------
        // name min of 3 chars
        //---------------------
        this.errors.push('Name must be a minimum of 3 characters.')
        this.errorFields.push('name')
      }
      //-----------------------
      // continue if no errors
      //-----------------------
      if (this.errors.length == 0) {
        //--------------------
        // load calc'ed props
        //--------------------
        this.local_race.ca = this.ca
        this.local_race.cr = this.ca
        this.local_race.sr = this.sr
        this.local_race.damage_mod = this.damage_mod
        //----------
        // set parm
        //----------
        let parms = {
          race: this.local_race,
          chars_changed: false,
        }
        //---------------------
        // check add or update
        //---------------------
        if (this.race != null) {
          this.submitCommitted = true
          //--------------------
          // have chars changed
          //--------------------
          parms.chars_changed = isCharacteristicsChanged(
            this.original_chars,
            this.local_race,
          )
          //-------------
          // update race
          //-------------
          this.updateRace(parms)
        } else {
          this.submitCommitted = true
          //----------
          // add race
          //----------
          this.addRace(parms)
        }
      }
    },
    //========================================================
    // add race
    //----------
    addRace(parms) {
      this.emitter.emit('close-race-side-panel', false)
      this.emitter.emit('add-race', parms)
    },
    //========================================================
    // update race
    //-------------
    updateRace(parms) {
      this.emitter.emit('close-race-side-panel', false)
      this.emitter.emit('update-race', parms)
    },
    //========================================================
    // set race
    //----------
    setRace(char_default_val, char_default_min, char_default_max) {
      this.local_race = setRaceValues(
        char_default_val,
        char_default_min,
        char_default_max,
      )
      this.syncOriginalRaceState()
    },
    //========================================================
    // next race
    //-----------
    nextRace() {
      this.emitter.emit('next-race', this.local_race)
    },
    //========================================================
    // previous race
    //---------------
    prevRace() {
      this.emitter.emit('previous-race', this.local_race)
    },
    //========================================================
    // on key down
    //-------------
    onKeyDown(e) {
      if (!isAlphanumeric(e)) e.preventDefault()
    },
    //========================================================
    // check toggles
    //---------------
    chkToggleClick(id, this_value) {
      switch (id) {
        case 'special_action':
          if (this.local_race.special_action != this_value) {
            this.onToggleClick(id)
          }
          break
        case 'special_reaction':
          if (this.local_race.special_reaction != this_value) {
            this.onToggleClick(id)
          }
          break
        case 'character_race':
          if (this.local_race.character_race != this_value) {
            this.onToggleClick(id)
          }
          break
      }
    },
    //========================================================
    // toggle clicker (sliders)
    //--------------------------
    onToggleClick(id) {
      switch (id) {
        case 'special_action':
          this.local_race.special_action = !this.local_race.special_action
          break
        case 'special_reaction':
          this.local_race.special_reaction = !this.local_race.special_reaction
          break
        case 'character_race':
          this.local_race.character_race = !this.local_race.character_race
          break
      }
    },
    //========================================================
    // close side panel
    //------------------
    closeSidePanel() {
      this.emitter.emit('close-race-side-panel', false)
    },
    //========================================================
    // force initial focus
    //---------------------
    forceInitialFocus() {
      this.editingMode = true
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    },
    //========================================================
    // capitalise after special char
    //-------------------------------
    capitaliseAfterSpecialChar() {
      //--------------------------
      // set name as target field
      //--------------------------
      let el = document.getElementById('name')
      //------------------------
      // listen to name keydown
      //------------------------
      el.addEventListener('keydown', function (e) {
        //--------------------
        // ignore command key
        //--------------------
        if (
          e.key !== 'Delete' &&
          e.key !== 'Backspace' &&
          !e.shiftKey &&
          !e.ctrlKey &&
          !e.option &&
          !e.altKey
        ) {
          let fieldVal = String(e.target.value)
          //---------------------
          // check previous char
          //---------------------
          let prevChar = fieldVal.charAt(e.target.value.length - 1)
          //------------------------------------
          // uc this char if prev = apos/hyphen
          //------------------------------------
          if (prevChar == "'" || prevChar == '-') {
            let key = e.key.toUpperCase()
            e.target.value = e.target.value + key
            e.preventDefault()
          }
        }
      })
    },
  },
  //========================================================
  // mounted
  //---------
  mounted() {
    //-----------------------------------
    // set capitalise after special char
    //-----------------------------------
    this.capitaliseAfterSpecialChar()
    //---------------------------
    // race image selection
    //---------------------------
    var fileInput = document.getElementById('selectImage')
    //-------------------
    // display new image
    //-------------------
    const preview = async (event) => {
      const file = event.target.files[0]
      const url = await readURL(file)
      this.local_race.image = url
      // create arena file for uploading
      const formData = new FormData()
      formData.append('image', file)
      this.local_race.image_file = formData
    }
    //-----------------------------
    // convert file to a base64 url
    //------------------------------
    const readURL = (file) => {
      return new Promise((res, rej) => {
        const reader = new FileReader()
        reader.onload = (e) => res(e.target.result)
        reader.onerror = (e) => rej(e)
        reader.readAsDataURL(file)
      })
    }
    //-----------------------
    // arena image selection
    //-----------------------
    fileInput.addEventListener('change', preview)
    //---------------------
    // get dropdown values
    //---------------------
    this.getDropDownValues()
    //------------------------
    // set initial input focus
    //------------------------
    this.forceInitialFocus()
    //---------------------------
    // save name of unique check
    //---------------------------
    if (this.race) this.original_name = this.race.name
    //---------------------------
    // load existing race values
    //---------------------------
    if (this.race != null) {
      this.loadRace(this.race, this.char_default_val)
      this.new_race = false
    } else {
      //---------------------
      // set new race values
      //----------------------
      this.setRace(
        this.char_default_val,
        this.char_default_min,
        this.char_default_max,
      )
      this.new_race = true
    }
    //-----------------------------------
    // load race emitter (for next/prev)
    //-----------------------------------
    this.emitter.on('load-race', (race) => {
      this.loadRace(race, this.char_min, this.char_max)
    })
    //---------------
    // counter emits
    //---------------
    this.emitter.on('counter_override_sr', (return_count) => {
      this.override_sr = return_count
    })
    //
    this.emitter.on('counter_str', (return_count) => {
      this.local_race.str = return_count
    })
    this.emitter.on('counter_str_min', (return_count) => {
      this.local_race.str_min = return_count
    })
    this.emitter.on('counter_str_max', (return_count) => {
      this.local_race.str_max = return_count
    })
    //
    this.emitter.on('counter_con', (return_count) => {
      this.local_race.con = return_count
    })
    this.emitter.on('counter_con_min', (return_count) => {
      this.local_race.con_min = return_count
    })
    this.emitter.on('counter_con_max', (return_count) => {
      this.local_race.con_max = return_count
    })
    //
    this.emitter.on('counter_dex', (return_count) => {
      this.local_race.dex = return_count
    })
    this.emitter.on('counter_dex_min', (return_count) => {
      this.local_race.dex_min = return_count
    })
    this.emitter.on('counter_dex_max', (return_count) => {
      this.local_race.dex_max = return_count
    })
    //
    this.emitter.on('counter_siz', (return_count) => {
      this.local_race.siz = return_count
    })
    this.emitter.on('counter_siz_min', (return_count) => {
      this.local_race.siz_min = return_count
    })
    this.emitter.on('counter_siz_max', (return_count) => {
      this.local_race.siz_max = return_count
    })
    //
    this.emitter.on('counter_int', (return_count) => {
      this.local_race.int = return_count
    })
    this.emitter.on('counter_int_min', (return_count) => {
      this.local_race.int_min = return_count
    })
    this.emitter.on('counter_int_max', (return_count) => {
      this.local_race.int_max = return_count
    })
    //
    this.emitter.on('counter_pow', (return_count) => {
      this.local_race.pow = return_count
    })
    this.emitter.on('counter_pow_min', (return_count) => {
      this.local_race.pow_min = return_count
    })
    this.emitter.on('counter_pow_max', (return_count) => {
      this.local_race.pow_max = return_count
    })
    //
    this.emitter.on('counter_cha', (return_count) => {
      this.local_race.cha = return_count
    })
    this.emitter.on('counter_cha_min', (return_count) => {
      this.local_race.cha_min = return_count
    })
    this.emitter.on('counter_cha_max', (return_count) => {
      this.local_race.cha_max = return_count
    })
    this.emitter.on('counter_move', (return_count) => {
      this.local_race.move = return_count
    })
    this.emitter.on('counter_move_fly', (return_count) => {
      this.local_race.move_fly = return_count
    })
    //-------------------------
    // save original race state
    //-------------------------
    this.syncOriginalRaceState()
  },
}
</script>
<!--------------------------------------->
<!-- style scoped (v-select dropdowns)  -->
<!---------------------------------------->
<style scoped>
:deep() {
  --vs-controls-color: #25bfda;
  --vs-controls-size: 1;
  --vs-dropdown-bg: black;
  --vs-dropdown-color: #25bfda;
  --vs-dropdown-option-color: #25bfda;
  --vs-dropdown-option--active-bg: #1e99ae;
  --vs-dropdown-option--active-color: white;
  --vs-selected-color: white;
}
</style>
<!-------------------------------------->
<!-- style scss (counters/toggles)    -->
<!-- import "./node_modules/vue-enhanced-check/src/styles/common.scss";-->
<!-------------------------------------->
<!-- <style lang='scss'>

$colors: (
  border: #51626f,
  default: #aaaaaa,
  ddefault: #dddddd,
  hdefault: #777777,
  primary: #1e99ae,
  dprimary: rgba(51, 122, 183, 0.5),
  success: #5cb85c,
  dsuccess: rgba(92, 184, 92, 0.5),
  danger: #d9534f,
  ddanger: rgba(217, 83, 79, 0.5),
  warning: #f0ad4e,
  dwarning: rgba(240, 173, 78, 0.5),
);

@mixin colorToggle($color, $colorDisabled) {
  .enhancedToggle-label {
    background: $color !important;
    color: white;
  }
  &.enhancedCheck-disabled .enhancedToggle-label {
    background: $colorDisabled !important;
  }
}

// toggle switch
.enhancedToggle {
  font-size: 1.8vh;
  background-color: white;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  user-select: none;
  cursor: pointer;
  height: 2em;
  border-radius: 5px !important;
  // @include colorToggle(color(default), color(ddefault));
  border: 1px solid red; 
  // color(border);
  // border-radius: $radiusDefault;
  margin-top: 5px;
  margin-bottom: 5px;
  &.enhancedCheck-rounded {
    // border-radius: $radiusRound;
    border-radius: 5;
  }

  label {
    position: absolute;
    top: 0;
    bottom: 0;
    left: -100%;
    width: 200%;
    transition: left 0.7s;
    -webkit-transition: left 0.7s;
    // transition: left $transitionTimeToggle;
    // -webkit-transition: left $transitionTimeToggle;
  }
  &.enhancedCheck-checked label {
    left: 0;
  }
  &.enhancedCheck-disabled label {
    cursor: not-allowed;
  }
  &.enhancedCheck-primary {
    @include colorToggle(color(primary), color(dprimary));
  }
  &.enhancedCheck-success {
    @include colorToggle(color(success), color(dsuccess));
  }
  &.enhancedCheck-warning {
    @include colorToggle(color(warning), color(dwarning));
  }
  &.enhancedCheck-danger {
    @include colorToggle(color(danger), color(ddanger));
  }

  .enhancedToggle-label {
    padding: $paddingVertical $paddingHorizontal;
    // transition: background $transitionTimeToggle;
    // -webkit-transition: background $transitionTimeToggle;
    transition: left 0.7s;
    -webkit-transition: left 0.7s;

    position: absolute;
    top: 0;
    bottom: 0;
    border-radius: 5px;
    // border-radius: $radiusDefault;

    // background-color: red !important;
    color: inherit;
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    text-align: center;

    &.labelOn {
      left: 0;
      padding-right: $paddingHorizontal + 30px;
    }
    &.labelOff {
      right: 0;
      padding-left: $paddingHorizontal + 30px;
    }
  }

  // TW - handle bit of the toggle

  .enhancedToggle-switch {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50px;
    // border: 1px solid color(border);
    border: 1px solid white !important;
    border-radius: $radiusDefault;
    width: 20px;
    z-index: 20;
    background: white;
  }

  &.enhancedCheck-rounded {
    .enhancedToggle-label,
    .enhancedToggle-switch {
      border-radius: $radiusRound;
    }
  } -->
<!-- }
</style> -->
